"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFreegrantAminoConverters = void 0;
function createFreegrantAminoConverters() {
    return {
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance": "not_supported_by_chain",
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance": "not_supported_by_chain",
    };
}
exports.createFreegrantAminoConverters = createFreegrantAminoConverters;
//# sourceMappingURL=aminomessages.js.map